import useOrgAccounts from './hooks/useOrgAccounts';
import { useParams } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '@/src/Common/components/Loading';
import { Button } from '@/src/shadComponents/ui/button';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/src/shadComponents/ui/table';

type Account = {
    username: string;
    email: string;
    id: number;
    firstName: string;
    lastName: string;
};

export default function OrgAccounts() {
    const navigate = useNavigate();
    const { orgId } = useParams();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [accounts, setAccounts] = useState<Account[]>([]);
    const { getAccounts } = useOrgAccounts();

    useEffect(() => {
        let isMounted = true;
        const fetchData = async () => {
            try {
                const response = await getAccounts(orgId ? +orgId : 0);
                setAccounts(response);
            } catch (error) {
                console.error(error);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return <Loading isLoading={true} />;
    }

    return (
        <div className="border-none relative">
            <div className="flex items-center justify-between px-8 py-4">
                <h2 className="text-lg font-semibold tracking-tight text-foreground">
                    Accounts
                </h2>
                <Button
                    onClick={(e) => {
                        e.preventDefault();
                        navigate('account/create');
                    }}
                >
                    <Plus className="size-4" />
                    Create Account
                </Button>
            </div>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Email</TableHead>
                        <TableHead className="text-right">Actions</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {accounts.map((account) => (
                        <TableRow key={account.id}>
                            <TableCell>
                                <div className="text-sm font-medium leading-6 text-foreground">
                                    {account.firstName}{' '}
                                    {account.lastName}
                                </div>
                            </TableCell>
                            <TableCell>
                                <div className="text-sm text-muted-foreground">
                                    {account.email}
                                </div>
                            </TableCell>
                            <TableCell className="text-right">
                                {/* Actions placeholder */}
                            </TableCell>
                        </TableRow>
                    ))}
                    {accounts.length === 0 && (
                        <TableRow>
                            <TableCell
                                colSpan={3}
                                className="text-center text-muted-foreground py-8"
                            >
                                <div className="space-y-4">
                                    <p>No accounts found</p>
                                    <Button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate('account/create');
                                        }}
                                    >
                                        <Plus className="size-4" />
                                        Create Account
                                    </Button>
                                </div>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </div>
    );
}
